<template>
    <div class="form-group" :class="{'has-error': error }">
        <label v-if="label" :for="name" class="label">{{ label }}</label>
        <div class="field-group">
            <flat-pickr
                :value="value"
                :name="name"
                :config="config"
                class="text max-w-md"
                @input="updateValue"
                @change="updateValue"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
            />
            <Transition name="fade">
                <p v-show="error" class="error">{{ error }}</p>
            </Transition>
        </div>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import { Dutch } from 'flatpickr/dist/l10n/nl';

    export default {
        name: 'DateInput',
        components: {
            flatPickr,
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            maxDate: {
                required: false,
                default: null,
                validator: value => null || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof Array || typeof value === 'number',
            },
            minDate: {
                required: false,
                default: null,
                validator: value => null || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof Array || typeof value === 'number',
            },
            preSelected: {
                required: false,
                default: null,
                validator: value => null || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof Array || typeof value === 'number',
            },
            value: {
                type: [String, Date],
                required: false,
                default: null,
            },
            error: {
                type: String,
                required: false,
                default: null,
            },
            enableTime: {
                type: Boolean,
                required: false,
                default: false,
            },
            type: {
                type: String,
                default: 'text',
                validate: val => ['text', 'url', 'email', 'password', 'search'].indexOf(val) !== -1,
            },
        },
        data() {
            return {
                config: {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    locale: Dutch,
                },
            };
        },
        methods: {
            updateValue(val) {
                this.$emit('input', val);
            },
        },
    };
</script>
